export default {
    title: 'EMPRESAS DE TRANSPORTE ADERIDAS',
    subtitle: 'Para mais informações, clique nos nomes das empresas',
    filter: 'Filtrar empresas por:',
    all: 'Todos os países',
}